import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/zanwupinglun@3x.png'


const _withScopeId = n => (_pushScopeId("data-v-27483154"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navBar" }
const _hoisted_2 = {
  key: 0,
  class: "isData"
}
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "userBox" }
const _hoisted_5 = { class: "left" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "right" }
const _hoisted_8 = { class: "content" }
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dir" }, null, -1 /* HOISTED */))
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 1,
  style: {"padding-bottom":"env(safe-area-inset-bottom)"}
}
const _hoisted_13 = {
  class: "allTitle",
  id: "activity1"
}
const _hoisted_14 = {
  key: 0,
  class: "noCommentBox"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "noComment",
  src: _imports_0,
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_16 = {
  key: 1,
  style: {"margin-bottom":"80px"}
}
const _hoisted_17 = { class: "commentList" }
const _hoisted_18 = { class: "contentBox" }
const _hoisted_19 = { class: "centerbox" }
const _hoisted_20 = { class: "name" }
const _hoisted_21 = { class: "time" }
const _hoisted_22 = { class: "commentContent" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["src"]
const _hoisted_25 = {
  key: 1,
  class: "chatFooter",
  style: {"padding-bottom":"env(safe-area-inset-bottom)"}
}
const _hoisted_26 = { class: "inputBox" }
const _hoisted_27 = ["src"]
const _hoisted_28 = ["src"]
const _hoisted_29 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_sticky = _resolveComponent("van-sticky")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_field = _resolveComponent("van-field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_sticky, { "offset-top": 0 }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "left",
            onClick: $setup.back
          }, [
            _createCommentVNode(" <img src=\"@/assets/images/jiantou.png\" alt=\"\"> "),
            _createVNode(_component_van_icon, {
              name: "arrow-left",
              size: "20",
              class: "back"
            }),
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('home.ballcircle')), 1 /* TEXT */)
          ]),
          ($setup.data && !$setup.offComments)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "right",
                onClick: $setup.scrollToAnchor
              }, _toDisplayString($setup.data.comment_num) + _toDisplayString(_ctx.$t('home.reply')), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _: 1 /* STABLE */
    }),
    ($setup.data)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString($setup.data.title), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                src: $setup.data.head,
                alt: ""
              }, null, 8 /* PROPS */, _hoisted_6),
              _createElementVNode("div", null, _toDisplayString($setup.data.name), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_7, _toDisplayString($setup.data.time), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_8, _toDisplayString($setup.data.content), 1 /* TEXT */),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.img_list, (item) => {
            return (_openBlock(), _createElementBlock("div", null, [
              _createElementVNode("img", {
                class: "imgItem",
                src: item,
                alt: ""
              }, null, 8 /* PROPS */, _hoisted_9)
            ]))
          }), 256 /* UNKEYED_FRAGMENT */)),
          _hoisted_10,
          ($setup.commentAdImg !== '')
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: $setup.commentAdImg,
                alt: "",
                class: "commentBanner",
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.toLocationBrowser($setup.commentAdUrl)))
              }, null, 8 /* PROPS */, _hoisted_11))
            : _createCommentVNode("v-if", true),
          (!$setup.offComments)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('home.allComment')), 1 /* TEXT */),
                ($setup.commentList.length == 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('noData.noComment')), 1 /* TEXT */)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.commentList, (item) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createVNode(_component_van_image, {
                              round: "",
                              width: "30px",
                              height: "30px",
                              src: item.head
                            }, null, 8 /* PROPS */, ["src"]),
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("div", _hoisted_20, _toDisplayString(item.name), 1 /* TEXT */),
                              _createElementVNode("div", _hoisted_21, _toDisplayString(item.time), 1 /* TEXT */),
                              _createElementVNode("div", _hoisted_22, _toDisplayString(item.content), 1 /* TEXT */)
                            ])
                          ]),
                          _createElementVNode("div", {
                            class: "commentZan",
                            onClick: ($event: any) => ($setup.tozan(item.comment_id, 2, item.is_zan == 0 ? 1 : 0))
                          }, [
                            _createElementVNode("img", {
                              src: item.is_zan == 0 ? $setup.zanIcon : $setup.zanIconSel,
                              alt: ""
                            }, null, 8 /* PROPS */, _hoisted_24),
                            _createElementVNode("div", null, _toDisplayString(item.zan), 1 /* TEXT */)
                          ], 8 /* PROPS */, _hoisted_23)
                        ]))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ]))
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    (!$setup.offComments)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_van_field, {
              modelValue: $setup.inputValue,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.inputValue) = $event)),
              placeholder: $setup.t('play.chatText'),
              style: {"background-color":"rgba(0, 0, 0, 0)"}
            }, null, 8 /* PROPS */, ["modelValue", "placeholder"])
          ]),
          ($setup.inputValue != '')
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: $setup.sendBtn,
                alt: "",
                onClick: $setup.sendMsg,
                class: "sendBtn"
              }, null, 8 /* PROPS */, _hoisted_27))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "zanbox",
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.tozan($setup.data.id, 1, $setup.data.is_zan == 0 ? 1 : 0)))
              }, [
                ($setup.data)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: $setup.data.is_zan == 0 ? $setup.zanIcon : $setup.zanIconSel,
                      alt: ""
                    }, null, 8 /* PROPS */, _hoisted_28))
                  : _createCommentVNode("v-if", true),
                ($setup.data)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString($setup.data.zan), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ]))
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}